import React from "react";
import Slider from "react-slick";
import { commingSoon } from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";

function EquityPortfolioAnalysis() {
  const Valuation = {
    dots: false,
    arrows: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="col-12 col-md-5 col-lg-4 equity-card-wrapper">
        <div className="card-box equity-card">
          <div className="card-title">
            <h2 className="small-title">
              {Constants.Equity_Portfolio_Analysis}
            </h2>
          </div>

          {/* <Slider {...Valuation} className="equity-slider equity"> */}

          {/* <div className="equity__item">
              <div className="equity-dot">
                <p className="dot" />
                <p className="title">valuation</p>
              </div>
              <div className="main-content">
                <h4 className="equity__item__percentage">59.0%</h4>
                <p className="description">
                  Of your portfolio has expensive or worse valuation
                </p>
              </div>
            </div> */}
          {/* <div className="equity__item">
              <div className="equity-dot">
                <p className="dot" />
                <p className="title">valuation</p>
              </div>
              <div className="main-content">
                <h4 className="equity__item__percentage">59.0%</h4>
                <p className="description">
                  Of your portfolio has expensive or worse valuation
                </p>
              </div>
            </div> */}
          {/* <div className="equity__item">
              <div className="equity-dot">
                <p className="dot" />
                <p className="title">valuation</p>
              </div>
              <div className="main-content">
                <h4 className="equity__item__percentage">59.0%</h4>
                <p className="description">
                  Of your portfolio has expensive or worse valuation
                </p>
              </div>
            </div> */}
          <div className="equity__item">
            {/* <span className="zeroBday">COMING SOON...</span> */}
            {/* <p>COMING SOON...</p> */}
          </div>
          {commingSoon()}

          {/* </Slider> */}
        </div>
      </div>
    </>
  );
}

export default EquityPortfolioAnalysis;
